import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708b9b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicators-statistic-info" }
const _hoisted_2 = { class: "indicators-statistic-info__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "indicators-statistic-info__title" }, "Статистика врачей", -1))
const _hoisted_4 = { class: "indicators-statistic-info__doctors" }
const _hoisted_5 = { class: "indicators-statistic-info__footer" }
const _hoisted_6 = { class: "indicators-statistic-info__footer-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Итого", -1))

import { computed, onUpdated } from 'vue'
import { StatisticDoctorType } from '@/shared/types'
import { REPORT_VIEW } from '@/shared/constants'

interface Props {
  doctors: StatisticDoctorType[]
  reportType: String
}


export default /*#__PURE__*/_defineComponent({
  props: {
    doctors: null,
    reportType: null
  },
  setup(__props: any) {

const props = __props as {
  doctors: StatisticDoctorType[]
  reportType: String
}

onUpdated(() => {
  props.doctors.sort((a, b) => {
    switch (props.reportType) {
      case REPORT_VIEW.plaqueIndex:
        return b.reports_count - a.reports_count
      case REPORT_VIEW.screening:
        return b.screenings_count - a.screenings_count
      case REPORT_VIEW.brushMap:
        return b.brush_maps_count - a.brush_maps_count
      case REPORT_VIEW.periodontal:
        return b.periodontologies_count - a.periodontologies_count
    }

    return 0
  })
})



const computeCountReports = (doctor: StatisticDoctorType) => {
  switch (props.reportType) {
    case REPORT_VIEW.plaqueIndex:
      return doctor.reports_count
    case REPORT_VIEW.screening:
      return doctor.screenings_count
    case REPORT_VIEW.brushMap:
      return doctor.brush_maps_count
    case REPORT_VIEW.periodontal:
      return doctor.periodontologies_count
  }

  return '-'
}

const totalReports = computed(() => {
  const initialValue = 0

  if (props.reportType === REPORT_VIEW.plaqueIndex) {
    return props.doctors.reduce(
      (accumulator, doctor) => accumulator + doctor.reports_count,
      initialValue
    )
  } else if (props.reportType === REPORT_VIEW.screening) {
    return props.doctors.reduce(
      (accumulator, doctor) => accumulator + doctor.screenings_count,
      initialValue
    )
  } else if (props.reportType === REPORT_VIEW.brushMap) {
    return props.doctors.reduce(
      (accumulator, doctor) => accumulator + doctor.brush_maps_count,
      initialValue
    )
  } else {
    return props.doctors.reduce(
      (accumulator, doctor) => accumulator + doctor.periodontologies_count,
      initialValue
    )
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.doctors, (doctor, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: doctor.id,
            class: "indicators-statistic-info__doctor"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(
              index === 0
                ? 'indicators-statistic-info__doctor-info__best'
                : 'indicators-statistic-info__doctor-info'
            )
            }, [
              _createElementVNode("div", null, _toDisplayString(doctor.name), 1),
              _createElementVNode("div", null, _toDisplayString(computeCountReports(doctor)), 1)
            ], 2),
            _createVNode(_component_el_divider)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_divider),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", null, _toDisplayString(_unref(totalReports)), 1)
      ]),
      _createVNode(_component_el_divider)
    ])
  ]))
}
}

})